'use client';

import { useEffect } from 'react';

interface ErrorBoundaryProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({
  error,
  reset,
}: ErrorBoundaryProps): React.JSX.Element {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('[App error]', error);
  }, [error]);

  return (
    <main
      id="main"
      className="flex min-h-[70vh] items-center justify-center bg-background px-5 py-24"
    >
      <div className="mx-auto max-w-xl text-center">
        <p className="text-[14px] uppercase tracking-[0.2em] text-accent">
          Something went wrong
        </p>
        <h1 className="mt-4 text-[48px] font-light leading-[0.9] text-foreground md:text-[72px] tracking-[-0.024em] md:tracking-[-0.029em]">
          We hit a <span className="text-accent">snag</span>
        </h1>
        <p className="mt-6 text-[16px] font-light leading-[1.4] text-muted md:text-[18px]">
          An unexpected error occurred while loading this page. Try again, or
          return to the homepage.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            type="button"
            onClick={reset}
            className="inline-flex items-center gap-2 rounded-full bg-accent px-8 py-4 text-[14px] font-normal uppercase tracking-[0.1em] text-background transition-opacity hover:opacity-90"
          >
            Try again
          </button>
          <a
            href="/"
            className="inline-flex items-center gap-2 rounded-full border border-border/30 px-8 py-4 text-[14px] font-normal uppercase tracking-[0.1em] text-foreground transition-colors hover:border-accent hover:text-accent"
          >
            Back to home
          </a>
        </div>
      </div>
    </main>
  );
}
